import { render, staticRenderFns } from "./UpdateRevenueModal.vue?vue&type=template&id=31466a87&"
import script from "./UpdateRevenueModal.vue?vue&type=script&lang=js&"
export * from "./UpdateRevenueModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports